/* eslint-disable no-restricted-imports */
import {ContinentCode, CountryCode} from '@colonist/types'
import {TranslationObject} from '@colonist/i18n'
import {clientIntl} from '../../../../../code/client/shared/scripts/ClientI18n'

export function getGlobeEmojiFexFromContinentCode(continentCode: string | undefined): string {
    switch(continentCode) {
        case 'NA':
        case 'SA':
            return '1f30e'
        case 'EU':
        case 'AF':
            return '1f30d'
        case 'AS':
        case 'OC':
            return '1f30f'
        default:
            return '1f30e'
    }
}

export function getFlagEmojiHexFromCountryCode(countryCode: string): string {
    // https://dev.to/jorik/country-code-to-flag-emoji-a21
    const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map((char) => 127397 + char.charCodeAt(0))
    return codePoints.map((i: number) => i.toString(16)).join('-')
}

export function getCountryOrContinentImageLink(countryCode: string | undefined, continentCode?: string | undefined, isUserOnDiscord?: boolean): string {
    const flagEmojiHexCode = (typeof countryCode === 'string') ? getFlagEmojiHexFromCountryCode(countryCode) : getGlobeEmojiFexFromContinentCode(continentCode)
    if(isUserOnDiscord) return `/.proxy/jsdelivr/npm/twemoji@11.0.1/2/svg/${flagEmojiHexCode}.svg`
    return `https://cdn.jsdelivr.net/npm/twemoji@11.0.1/2/svg/${flagEmojiHexCode}.svg`
}

export function getTooltipText(countryCode?: CountryCode, continentCode?: ContinentCode): TranslationObject {
    if(countryCode) return {key: 'strings:colonistCommon.utils.#buffer', options: {value: clientIntl.getCountryName(countryCode)}}
    if(continentCode) return {key: `strings:leaderboardPage.tabs.continents.${continentCode}`}
    return {key: 'strings:leaderboardPage.earth'}
}
